import { useState } from "react";
import { useFormikContext, getIn } from "formik";
import { SudoButton } from "src/sudokit/components/SudoButton";
import { generateId } from "../../../../../../../../src/shared/schemas/CharacterSchema";

function FeatureFlagsBlockEditor({ block, optionsPath }) {
  const { values, setFieldValue } = useFormikContext();
  const [newFlagName, setNewFlagName] = useState("");
  const currentFlags = getIn(values, `${optionsPath}.subscriptionFeatureFlags`);

  const addFlag = () => {
    if (newFlagName.trim()) {
      setFieldValue(`${optionsPath}.subscriptionFeatureFlags`, [...currentFlags, { id: generateId(), name: newFlagName.trim() }]);
      setNewFlagName("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addFlag();
    }
  };

  return (
    <div>
      {currentFlags.length > 0 &&
        currentFlags.map((flag) => (
          <div key={flag.id}>
            <span>{flag.name}</span>
            <SudoButton
              variant="tertiary"
              className="mt-0 w-fit"
              onClick={(e) => {
                e.preventDefault();
                setFieldValue(
                  `${optionsPath}.subscriptionFeatureFlags`,
                  currentFlags.filter((f) => f.id !== flag.id)
                );
              }}
            >
              Remove
            </SudoButton>
          </div>
        ))}
      <div className="flex flex-row gap-2 items-center">
        <div>
          <input
            type="text"
            placeholder="Flag Name"
            value={newFlagName}
            onChange={(e) => setNewFlagName(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <SudoButton
          variant="tertiary"
          className="mt-0 w-fit"
          onClick={(e) => {
            e.preventDefault();
            addFlag();
          }}
        >
          Add Flag
        </SudoButton>
      </div>
    </div>
  );
}

export default FeatureFlagsBlockEditor;
